var DateFieldDateFormat;

(function (DateFieldDateFormat) {
  DateFieldDateFormat["en_US"] = "MM/DD/YYYY";
  DateFieldDateFormat["en_AU"] = "DD/MM/YYYY";
  DateFieldDateFormat["ja_JP"] = "YYYY/MM/DD";
})(DateFieldDateFormat || (DateFieldDateFormat = {}));

export { DateFieldDateFormat };
